var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".close-cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}")),React.createElement("title",{"key":1},"close"),React.createElement("g",{"id":"Ebene_2","data-name":"Ebene 2","key":2},React.createElement("g",{"id":"Ebene_1-2","data-name":"Ebene 1"},[React.createElement("line",{"className":"close-cls-1","x1":"1.77","y1":"1.77","x2":"97.23","y2":"97.23","key":0}),React.createElement("line",{"className":"close-cls-1","x1":"97.23","y1":"1.77","x2":"1.77","y2":"97.23","key":1})]))]);
}

Close.defaultProps = {"viewBox":"0 0 99 99"};

module.exports = Close;

Close.default = Close;
